
import { Component, Vue, Watch } from "vue-property-decorator";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import MembershipCard from "../../../components/productCard/membershipCard.vue";
import ScrollableBanner from "@shared/crm/components/scrollableBanner.vue";


@Component({
  components: {
    MembershipCard,
    ScrollableBanner
  },
})
export default class MembershipsBanner extends Vue {
  memberships: any[] = [];

  @Watch("memberships", { immediate: true, deep: true })
  onMembershipsChanged(newMemberships: any[]) {
    if (newMemberships && newMemberships.length > 0) {
      this.generateBlobsByPageHeight();
    }
  }

  async mounted() {
    let url = `${Settings.HostName}/api/publicmemberships/list`;
    let data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash");
      return;
    }
    this.memberships = data.model;
  }
  

  generateBlobsByPageHeight() {
    this.$nextTick(() => {
      const container = this.$refs.blobsContainer as HTMLElement;
      if (!container) return;

      container.innerHTML = "";

      const topRightBlob = document.createElement("div");
      topRightBlob.className = "blob";
      topRightBlob.style.top = "-100px";
      topRightBlob.style.left = "-100px";
      topRightBlob.style.backgroundColor = "rgba(122, 122, 122, 0.3)";
      container.appendChild(topRightBlob);

      const bottomLeftBlob = document.createElement("div");
      bottomLeftBlob.className = "blob";
      bottomLeftBlob.style.bottom = "-100px";
      bottomLeftBlob.style.right = "-100px";
      bottomLeftBlob.style.backgroundColor = "rgba(122, 122, 122, 0.3)";
      container.appendChild(bottomLeftBlob);
    });
  }
}
